export const TOGGLE_TAG_CATEGORY_CHANGE = 'UI-COMPONENTS_TAGGING_TOGGLE_TAG_CATEGORY_CHANGE';
export const TOGGLE_TAG_VALUE_CHANGE = 'UI-COMPONENTS_TAGGING_TOGGLE_TAG_VALUE_CHANGE';
export const DELETE_ASSIGNED_TAG = 'UI-COMPONENTS_TAGGING_DELETE_ASSIGNED_TAG';
export const DELETE_ALL_ASSIGNED_TAGS = 'UI-COMPONENTS_TAGGING_DELETE_ALL_ASSIGNED_TAGS';
export const CHANGE_ASSIGNED_TAGS = 'UI-COMPONENTS_TAGGING_CHANGE_ASSIGNED_TAGS';
export const ADD_ASSIGNED_TAG = 'UI-COMPONENTS_TAGGING_ADD_ASSIGNED_TAG';
export const LOAD_STATE = 'UI-COMPONENTS_TAGGING_LOAD_STATE';
export const RESET_STATE = 'UI-COMPONENTS_TAGGING_RESET_STATE';
